import { gql } from '@apollo/client';

export const VERTRAEGE_KUENDIGEN = gql`
  mutation vertraege_kuendigen($input: vertraege_kuendigen!) {
    vertraege_kuendigen(input: $input)
  }
`;

export const VERTRAEGE_UPGRADEN = gql`
  mutation vertraege_upgraden($input: vertraege_upgrade!) {
    vertraege_upgraden(input: $input)
  }
`;
